/*
  Bonny & Rose: de maten op volgorde, van klein naar groot.

  Waarom dit nodig is: bij veel producten begonnen de maten pas bij L. De
  ontbrekende maten zijn later toegevoegd, en Shopify zet een nieuwe maat altijd
  achteraan de rij. Op de pagina stond er dan "L XL 2XL 3XL 4XL 5XL 6XL S M".

  Dit bestand zet de knoppen in de goede volgorde en zet de keuze op de kleinste
  maat, zodat een productpagina altijd bij Small begint. Het werkt op elk
  product, ook op producten die later worden toegevoegd, en het raakt de
  gegevens in Shopify niet aan.

  Staat er een maat tussen die we niet kennen (ONE SIZE bijvoorbeeld), dan blijft
  die rij precies zoals hij was. Liever niets doen dan een rij door elkaar gooien.
*/
(function () {
  'use strict';

  var LADDER = ['xs', 's', 'm', 'l', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl'];
  var POS = {};
  for (var i = 0; i < LADDER.length; i++) POS[LADDER[i]] = i;

  function rang(waarde) {
    var k = String(waarde || '').trim().toLowerCase();
    return Object.prototype.hasOwnProperty.call(POS, k) ? POS[k] : -1;
  }

  function sorteerRij(wrap) {
    var items = [].slice.call(wrap.querySelectorAll('.variant-input'));
    if (items.length < 2) return null;

    for (var i = 0; i < items.length; i++) {
      if (rang(items[i].getAttribute('data-value')) < 0) return null;
    }

    var op = items.slice().sort(function (a, b) {
      return rang(a.getAttribute('data-value')) - rang(b.getAttribute('data-value'));
    });

    var anders = false;
    for (var j = 0; j < op.length; j++) if (op[j] !== items[j]) { anders = true; break; }
    if (anders) for (var k = 0; k < op.length; k++) wrap.appendChild(op[k]);
    return op;
  }

  /* De kleinste maat aanzetten als er nu een grotere aanstaat. Zonder dit opent
     een product dat vroeger bij L begon nog steeds op L, terwijl S nu vooraan
     in de rij staat. */
  function kiesKleinste(op) {
    if (!op || !op.length) return;
    var aan = null;
    for (var i = 0; i < op.length; i++) {
      var r = op[i].querySelector('input[type="radio"]');
      if (r && r.checked) { aan = op[i]; break; }
    }
    /* Geen maat aan (sinds 2026-09-18 kiest zij zelf, zie br-size-required.js):
       dan ook niets aanklikken. Alleen een grotere maat die aanstaat gaat naar de kleinste. */
    if (aan === null || aan === op[0]) return;

    var eerste = op[0].querySelector('input[type="radio"]');
    if (!eerste || eerste.classList.contains('disabled')) return;
    eerste.click();
  }

  function doe() {
    var wraps = document.querySelectorAll('.variant-input-wrap');
    for (var i = 0; i < wraps.length; i++) {
      var naam = (wraps[i].getAttribute('data-handle') || '').toLowerCase();
      if (naam && naam !== 'size') continue;
      kiesKleinste(sorteerRij(wraps[i]));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', doe);
  } else {
    doe();
  }

  /* Bij een kleurwissel wordt de productsectie opnieuw opgehaald en staat de
     rij weer in de oude volgorde. */
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(doe, 60);
  });
})();
